module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (102).df82d879.jpg";